import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    redactPrivate,
    Sheet,
    YStack,
} from 'smoothie';

import { getLastFourAccountNumber } from '../../../common/utils/bankingUtils';

interface CheckDepositEndorsementSheetProps {
    isOpen: boolean;
    accountNumberMasked: string;
    onClose: () => void;
    onContinue: () => void;
}

export const CheckDepositEndorsementSheet = ({
    isOpen,
    accountNumberMasked,
    onClose,
    onContinue,
}: CheckDepositEndorsementSheetProps) => {
    const accountLastFour = getLastFourAccountNumber(accountNumberMasked);

    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            title="Important"
            showCloseButton
        >
            <YStack gap={16} maxWidth={500} {...redactPrivate()}>
                <BodyMediumRegular>
                    {accountLastFour === ''
                        ? 'Account number unavailable.'
                        : `You must sign the back of your check and write "For Mobile Deposit Only to Fruitful *${accountLastFour}"`}
                </BodyMediumRegular>
                <Button
                    marginTop={8}
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Got it"
                    onPress={onContinue}
                    disabled={accountLastFour === ''}
                />
            </YStack>
        </Sheet>
    );
};
